<div class="sidepanel-container" *ngIf="hide">
    <div class="block-title">
      <h2><span class="max-width-tooltip-400" appEllipsifyMe>{{eandO.agencyName ? eandO.agencyName : eandO.policyHolderFirstName + ' ' + eandO.policyHolderLastName}}</span></h2>
      <div class="close-box">
       <button type="button" class="modal-close-btn close" (click)="closePopup(null)" style="margin-left: 16px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
            <rect width="28" height="28" rx="6" fill="none" />
            <g transform="translate(4 4)">
              <rect width="20" height="20" fill="none" />
              <path d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                    transform="translate(-0.005 0.005)" fill="#757575" />
            </g>
          </svg>
        </button>
      </div>
    </div>
    <div class="tab common-tab p-0" role="tabpanel">
      <ul class="nav nav-tabs fixed px-2" role="tablist">
        <li class="nav-item" *ngIf="sidePanelData.tabIndex.includes('1')">
          <a class="nav-link" (contextmenu)="$event.preventDefault()" [ngClass]="sidePanelData.activeTab == '1' ? 'active' : ''" href="#sidenotes" aria-controls="error-omission" role="tab" data-toggle="tab">
            Notes <span *ngIf="notesCount > 0">({{notesCount}})</span></a>
        </li>
        <li class="nav-item" *ngIf="sidePanelData.tabIndex.includes('2')">
          <a class="nav-link" (contextmenu)="$event.preventDefault()" [ngClass]="sidePanelData.activeTab == '2' ? 'active' : ''" href="#sideattachments" aria-controls="error-omission" role="tab"
             data-toggle="tab">Attachments <span *ngIf="attachmentCount > 0">({{attachmentCount}})</span></a>
        </li>
        <li class="nav-item" *ngIf="sidePanelData.tabIndex.includes('3')">
          <a class="nav-link" (contextmenu)="$event.preventDefault()" [ngClass]="sidePanelData.activeTab == '3' ? 'active' : ''" href="#sideattachmentsarchive" aria-controls="error-omission" role="tab"
             data-toggle="tab">Archived Attachments <span *ngIf="archiveAttachmentCount > 0">({{archiveAttachmentCount}})</span></a>
        </li>
      </ul>
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane" id="sidenotes" *ngIf="sidePanelData.tabIndex.includes('1')" [ngClass]="sidePanelData.activeTab == '1' ? 'active' : ''" >
          <app-side-notes-error-omissions [sidePanelData]="sidePanelData" [eandO]="eandO" (getEandONotesCountEvent)="getEandONotesCountEvent($event)"></app-side-notes-error-omissions>
        </div>
        <div role="tabpanel" class="tab-pane" id="sideattachments" *ngIf="sidePanelData.tabIndex.includes('2')" [ngClass]="sidePanelData.activeTab == '2' ? 'active' : ''">
          <app-side-attachments-error-omissions [sidePanelData]="sidePanelData" [eandO]="eandO" [archive]="false"></app-side-attachments-error-omissions>
        </div>
        <div role="tabpanel" class="tab-pane" id="sideattachmentsarchive" *ngIf="sidePanelData.tabIndex.includes('3')" [ngClass]="sidePanelData.activeTab == '3' ? 'active' : ''">
          <app-side-attachments-error-omissions [sidePanelData]="sidePanelData" [eandO]="eandO" [archive]="true" ></app-side-attachments-error-omissions>
        </div>
      </div>
    </div>
  </div>
